import React from 'react';

export interface AuthContextValue {
  signed: boolean;
  setSigned: (value: boolean) => void;
}

export const authContextDefaultValue: AuthContextValue = {
  signed: false,
  setSigned: () => {},
};

export const AuthContext = React.createContext<AuthContextValue>(authContextDefaultValue);

export const useAuth = () => {
  return React.useContext(AuthContext);
};
